"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfDefendingTemplate = SelfDefendingTemplate;
function SelfDefendingTemplate() {
    return `
        const {selfDefendingFunctionName} = {callControllerFunctionName}(this, function () {
            if ({selfDefendingFunctionName}.bind().toString().indexOf('\\n') !== -1) {
                return;
            }

            return {selfDefendingFunctionName}
                .toString()
                .search('(((.+)+)+)+$')
                .toString()
                .constructor({selfDefendingFunctionName})
                .search('(((.+)+)+)+$');
        });

        {selfDefendingFunctionName}();
    `;
}
